import React from 'react'
import Constants from 'EurestoFonction/Constants'

import Formulaire from 'Components/Formulaire'
import Template from '../../Component/Message/Form'
import User from 'EurestoClass/User'
import {Grid} from '@material-ui/core'
import EmojiEuresto from 'Components/Emoji'
import moment from 'moment'
import Data from 'EurestoClass/Data'
import Tooltip from '@material-ui/core/Tooltip'
import {browserHistory} from 'react-router'
import Search from '../../Component/Cas/Search'
import h2p from 'html2plaintext'

moment.locale('fr')

const columns = [{
  header: 'Id',
  id: 'id',
  show: false,
},
  {
    header: '',
    minWidth: 30,
    Cell: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
                         justify={'flex-start'}>{d.flags.map(flag => <EmojiEuresto flag={flag}/>)}
    </Grid>,
    type: 'string',
    id: 'flags',
    sortable: false
  },
  {
    header: <span>{EurestoI18n.t('commun:Date')}</span>,
    width: 100,
    id: 'date_modification',
    type: 'date',
    Cell: (row) => <span style={{
      color: row.importance === 1 && EurestoColor('EurestoError') || row.importance !== 0 && EurestoColor('disabled', '')
    }}>{moment(row.date_modification).format('DD/MM/YY HH:mm')}</span>
  },
  {
    header: <span style={{ float: 'left' }}>{EurestoI18n.t('commun:Nom')}</span>,
    sortable: false,
    type: 'string',
    minWidth: 200,
    Cell: (row) => {
      return <span style={{ float: 'left' }}>
            <b className={row.status === 0 && 'EurestoError--text'}>{row.libelle || ''}</b>
          </span>
    }
  },
  {
    header: <span>{EurestoI18n.t('commun:Message')}</span>,
    sortable: false,
    type: 'string',
    Cell: d => <Tooltip disableTouchListener placement="bottom-start" title={
      <div
        style={{
          fontSize: 15,
          padding: 5,
          paddingLeft: 10,
          paddingRight: 10,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: '-moz-pre-wrap',
          //wordBreak: 'break-all',
          overflowWrap: 'break-word',
          textAlign: 'left',
          //lineHeight: '15px',
        }} dangerouslySetInnerHTML={{ __html: d.message.replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span>') }}/>
    }>
      <span style={{ float: 'left' }}>{h2p(d.message)}</span>
    </Tooltip>,
    id: 'message',
  },
  {
    id: 'user_id',
    header: <span>{EurestoI18n.t('commun:Par')}</span>,
    width: 120,
    type: 'string',
    Cell: (row) => {
      return <span>{Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: row.user_id }) && Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: row.user_id }).slibelle}</span>
    }
  },
  {
    id: 'user_assign_id',
    type: 'string',
    header: <span>{EurestoI18n.t('commun:Assigné à')}</span>,
    width: 120,
    Cell: (row) => {
      return <span
        className={!row.etat && 'EurestoError--text'}>{row.user_assign_id !== null && row.user_assign_id !== undefined && (Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: row.user_assign_id }) && Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: row.user_assign_id }).slibelle || Data.get(Constants.module.CONFIGURATION, Constants.donnee.groupe_utilisateur, { id: row.user_assign_id }) && Data.get(Constants.module.CONFIGURATION, Constants.donnee.groupe_utilisateur, { id: row.user_assign_id }).libelle)}</span>
    }
  },

  {
    header: <span>{EurestoI18n.t('commun:Intervention')}</span>,
    width: 120,
    type: 'date',
    id: 'date_intervention',
    Cell: (row) => row.date_intervention &&
      <span>{moment(row.date_intervention, 'YYYY-MM-DD').format('DD/MM/YY')}</span> || ''
  },]

export default React.memo(props => {

  const onClick = (row) => {
    browserHistory.push({
      pathname: '/crm/' + row.contact_id,
      state: {
        dossier_id: row.dossier_id || undefined,
        classeur_id: row.classeur_id,
        action_id: row.action_id,
        UserTabSelected: 2,
        dossier_status: row.status
      }
    })
  }

  return <Formulaire infinityScroll={true}
                     showSearchComponent={props.route && props.route.showSearch}
                     searchComponent={props.route && props.route.showSearch && <Search
                       defaultSearch={props.route && props.route.defaultSearch}
                       searchName={props.route && props.route.searchName}
                     />}
                     btns={props.route && props.route.btns || []}
                     onClick={props.route && props.route.onClick || onClick}
                     maxHeight={props.route && props.route.maxHeight}
                     title={props.route && props.route.title || false}
                     showForm={false}
                     isAllow={props.route && props.route.isAllow || {}}
                     handleAction={props.route && props.route.handleAction || {}}
                     formStyle={{ padding: 0 }}
                     setAllow={() => props.route && props.route.setAllow || ({ associate: true })}
                     search={props.search || ((props.route && props.route.searchName || 'cas_') + (props.name || '') + User.Entite.get().id)}
                     form={<Template/>}
                     module={Constants.module.SDD} requete={Constants.donnee.dossier} columns={columns}/>
})


// WEBPACK FOOTER //
// ./app/App/Module/SDD/Page/Cas/index.js